"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buffer = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Buffer = exports.Buffer = function () {

  /**
   * Constructor that allows the setting of the size.
   * @param {int} size
   */
  function Buffer() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
    (0, _classCallCheck3.default)(this, Buffer);

    this._content = [];
    this._size = size;
  }

  /**
   * Returns an array representation of the current buffer state.
   * @returns {Array}
   */


  (0, _createClass3.default)(Buffer, [{
    key: "toArray",
    value: function toArray() {
      return this._content;
    }

    /**
     * Adds a new element to the buffer.
     * @param element
     */

  }, {
    key: "push",
    value: function push(element) {
      this._content.push(element);
      if (this._content.length > this._size) {
        this._content.splice(0, this._content.length.length - this._size);
      }
    }

    /**
     * The size of the buffer: every element more than the size will be discarded.
     * @type {int}
     * @private
     */


    /**
     * The contents of the buffer.
     * @type {Array}
     * @private
     */

  }]);
  return Buffer;
}();